var countdownBanner = (function($) {
    'use strict';

    function init() {
        const timers = document.querySelectorAll(".timer");

        timers.forEach(function(timer) {
            const endDate = new Date(timer.dataset.endDate).getTime();
            const uniqueId = timer.dataset.uniqueId;
            const endMessage = document.querySelector(".end_message[data-unique-id='" + uniqueId + "']");

            const countdown = setInterval(function() {
                const now = new Date().getTime();
                const interval = endDate - now;

                if (interval <= 0) {
                    clearInterval(countdown);
                    timer.style.display = "none";
                    endMessage.style.display = "block";
                    return;
                }

                const days = Math.floor(interval / (1000 * 60 * 60 * 24));
                const hours = Math.floor((interval % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((interval % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((interval % (1000 * 60)) / 1000);

                timer.innerHTML =
                    "<p class='c-days'>" + days + "</p> <span>:</span>" +
                    "<p class='c-hours'>" + hours + "</p> <span>:</span>" +
                    "<p class='c-minutes'>" + minutes + "</p> <span>:</span>" +
                    "<p class='c-seconds'>" + seconds + "</p>";
            }, 1000);
        });
    }

    return {
        init:init
    };
}(jQuery));

jQuery(document).ready(function($) {
    countdownBanner.init();
});